import { render, staticRenderFns } from "./AdaptiveView.vue?vue&type=template&id=1fa96a1c&scoped=true"
import script from "./AdaptiveView.vue?vue&type=script&lang=js"
export * from "./AdaptiveView.vue?vue&type=script&lang=js"
import style0 from "./AdaptiveView.vue?vue&type=style&index=0&id=1fa96a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa96a1c",
  null
  
)

export default component.exports